import React from 'react';
import './_customBarChart.scss';
import ReactEcharts from 'echarts-for-react';
import { useTheme } from '@mui/material';
import { getCadrageEchartsOption } from './eChartsHelpers';

type Props = {
    cadrageValue?: number;
    data: {
        metric: string;
        value: number;
    };
    height: number;
    width: number;
    reverseColor: boolean;
};

const CadrageGaugeChart = ({
    cadrageValue = 0,
    data,
    height,
    width,
    reverseColor,
}: Props) => {
    const theme = useTheme();
    const options = getCadrageEchartsOption({
        height,
        width,
        cadrageValue,
        value: data.value,
        metric: data.metric,
        theme,
        reverseColor,
    });

    return <ReactEcharts option={options} style={{ height, width }} />;
};

export default CadrageGaugeChart;
